import React from "react";
import { Link } from "react-router-dom";
import "../css/Pages.css";

const Contact = () => {
  return (
    <>
      <div className="page contact-page">
        <h1 className="page-title">Contact Us</h1>
        <p className="page-subtitle">
          Have a question, feedback, or craving? We’re here to help and feed you.
        </p>

        <div className="contact-container">
          {/* Contact Info */}
          <div className="contact-details glow-card">
            <h2>Get in Touch</h2>

            <p>
              <strong>Email:</strong><br />
              support@foodies.com
            </p>

            <p>
              <strong>Phone:</strong><br />
              +91 9876543210
            </p>

            <p>
              <strong>Address:</strong><br />
              Foodies Restaurant,<br />
              MG Road, Mumbai,<br />
              Maharashtra, India
            </p>

            <p>
              <strong>Working Hours:</strong><br />
              Monday – Sunday<br />
              10:00 AM – 11:00 PM
            </p>

            <p className="contact-note">
              For bulk orders, catering, or partnerships, please contact us via
              email. We reply faster than most humans.
            </p>
          </div>

          {/* Map */}
          <div className="contact-map glow-card">
            <iframe
              title="Foodies Location"
              src="https://www.google.com/maps?q=Mumbai%20India&output=embed"
              width="100%"
              height="320"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>

      {/* Footer */}
     <footer className="footer">
  <div className="footer-content">
    <h3>Foodies</h3>
    <p>
      Serving delicious food with quality ingredients and a whole lot of love.
      Calories are temporary. Taste is forever.
    </p>

    <div className="footer-links">
      <Link to="/">Home</Link>
      <Link to="/menu">Menu</Link>
      <Link to="/services">Services</Link>
      <Link to="/contact">Contact</Link>
    </div>

    <p className="footer-copy">
      © 2026 Foodies. All rights reserved.
    </p>
  </div>
</footer>

    </>
  );
};

export default Contact;
